import { render, staticRenderFns } from "./step-tech-manufacturer-mobile.vue?vue&type=template&id=04e25b4f"
import script from "./step-tech-manufacturer-mobile.vue?vue&type=script&lang=ts"
export * from "./step-tech-manufacturer-mobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports